module.exports = __webpack_public_path__ + "img/35_24.bb914f83.png";